import {useCurrentUser} from '../../context/CurrentUserContext'

const LogOut = () => {
  const {logOut} = useCurrentUser()
  logOut()

  return null
}

export default LogOut